module.exports = __webpack_public_path__ + "static/media/nav-icon--home.3428cc18.svg";